export const UPDATE = "modules/UPDATE";
export const APPEND = "modules/APPEND";
export const UPDATE_ONE = "modules/UPDATE_ONE";
export const SET_SELECTED = "modules/SET_SELECTED";
export const DESTROY = "modules/DESTROY";
export const LOADING = "modules/LOADING";
